var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 51"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m45 1-8.85 1.6a25.8 25.8 0 0 0-11.8 6.9C19.175 14.9 13.4 26.475 11.1 31.3a3.38 3.38 0 0 0 .725 3.85l5.15 5a3.3 3.3 0 0 0 3.85.55A108.7 108.7 0 0 0 41.7 26.924a24.15 24.15 0 0 0 6.55-12.5L49.85 6A4.25 4.25 0 0 0 45 1m-5.9 17.975a5 5 0 1 1-7.263-6.873 5 5 0 0 1 7.263 6.872",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.4 17.65-6.95 13.024L0 30.4s9.575-14.625 18.4-12.75M35.2 32l-12.5 7.65.775 11.35S37.5 40.7 35.2 32m.25-21.426a5 5 0 1 0 0 10.001 5 5 0 0 0 0-10"
  })));
};
export default SvgRocket;